import {
  VENDOR_PRO_IMG_REQUEST,
  VENDOR_PRO_IMG_SUCCESS,
  VENDOR_PRO_IMG_FAIL
} from "../constants/AuthConstant";

const initialState = {
  loading: false,
  action: "Profile Action",
  result: [],
  msg: "",
  error: "",
};

const VendorUpdateProImgReducer = (state = initialState, action) => {
  switch (action.type) {
    case VENDOR_PRO_IMG_REQUEST:
      return {
        ...state,
        loading: action.payload,
      };
    case VENDOR_PRO_IMG_SUCCESS:
      return {
        ...state,
        result: action.result.data,
        loading: action.payload,
        msg: action.msg,
      };
    case VENDOR_PRO_IMG_FAIL:
      return {
        ...state,
        error: action.error,
        loading: action.payload,
        msg: action.msg,
      };

    default:
      return state;
  }
};

export default VendorUpdateProImgReducer;
